import { useIntl } from "react-intl";
import { getCurrentMonthDays } from "../../../../../../utils/dateUtils";
import { ScheduleViewType } from "../..";
import { ServiceBaySchedule } from "../../../../../../models/serviceBay";
import useMediaQuery from "@mui/material/useMediaQuery";

interface IMonthProps {
  currentDate: Date;
  consultantMonthSchedule: ServiceBaySchedule[];
  setCurrentDate: (date: Date) => void;
  setScheduleViewType: (scheduleViewType: ScheduleViewType) => void;
}

const Month = ({
  currentDate,
  consultantMonthSchedule,
  setCurrentDate,
  setScheduleViewType,
}: IMonthProps) => {
  const intl = useIntl();
  const weekdays = [
    intl.formatMessage({ id: "intl-msg:dealership.month.monday" }),
    intl.formatMessage({ id: "intl-msg:dealership.month.tuesday" }),
    intl.formatMessage({ id: "intl-msg:dealership.month.wednesday" }),
    intl.formatMessage({ id: "intl-msg:dealership.month.thursday" }),
    intl.formatMessage({ id: "intl-msg:dealership.month.friday" }),
    intl.formatMessage({ id: "intl-msg:dealership.month.saturday" }),
    intl.formatMessage({ id: "intl-msg:dealership.month.sunday" }),
  ];
  const days = getCurrentMonthDays(currentDate);
  const isResponsiveView = useMediaQuery("(max-width: 1024px)");

  return (
    <div className={isResponsiveView ? 'mobile-week-container' : ''}>
      <table className="width-100pct table-fixed">
        <thead>
          <tr>
          {weekdays.map((weekday, index) => (
            <th
              className={`height-20 text-medium ${isResponsiveView ? 'text-size-10 mobile-week-header' : 'text-size-12'}`}
              key={index}
            >
              {isResponsiveView ? weekday.substring(0, 1) : weekday}
            </th>
          ))}
          </tr>
        </thead>
        <tbody>
        {Array.from({ length: Math.ceil(days.length / 7) }).map(
          (_, weekIndex) => (
            <tr key={weekIndex}>
              {Array.from({ length: 7 }).map((_, dayIndex) => {
                let schedulings: ServiceBaySchedule[] = [];
                const day = days[weekIndex * 7 + dayIndex];

                let isCurrentDay = false;
                if (day > 0) {
                  const date = new Date(
                    currentDate.getFullYear(),
                    currentDate.getMonth(),
                    day
                  );

                  isCurrentDay =
                    date.getDate() === currentDate.getDate() &&
                    date.getMonth() === currentDate.getMonth() &&
                    date.getFullYear() === currentDate.getFullYear();

                  schedulings = consultantMonthSchedule.filter(
                    (scheduling: ServiceBaySchedule) => {
                      if (
                        !scheduling.startDate ||
                        !scheduling.endDate ||
                        scheduling.startDate.getMonth() !== date.getMonth() ||
                        scheduling.startDate.getFullYear() !==
                        date.getFullYear()
                      )
                        return false;
                      return (
                        scheduling.startDate.getDate() === date.getDate() ||
                        scheduling.endDate.getDate() === date.getDate() ||
                        (scheduling.startDate.getDate() < date.getDate() &&
                          scheduling.endDate.getDate() > date.getDate())
                      );
                    }
                  );
                }

                return (
                  <td
                    style={{
                      height: isResponsiveView ? 60 : 121,
                      width: isResponsiveView ? 45 : 100
                    }}
                    className={`
                                            text-center border
                                            ${isResponsiveView ? 'text-size-14' : 'text-size-18'}
                                            ${isCurrentDay
                        ? "bg-highlight-decent"
                        : ""
                      }
                                            ${day < 0
                        ? "text-color-gray cursor-text bg-lightest"
                        : "cursor-pointer"
                      }
                                        `}
                    onClick={() =>
                      day > 0 && [
                        setCurrentDate(
                          new Date(
                            currentDate.getFullYear(),
                            currentDate.getMonth(),
                            day
                          )
                        ),
                        setScheduleViewType("day"),
                      ]
                    }
                    key={`${weekIndex}_${dayIndex}`}
                  >
                    <div className="h-[100%]">
                      <div className="w-full text-left p-4 h-[50%] text-size-16">
                        {day < 0
                          ? day * -1 < 10
                            ? `0${day * -1}`
                            : day * -1
                          : day < 10
                            ? `0${day}`
                            : day}
                      </div>
                      <div className="w-full text-left relative h-[50%]">
                        <span className="absolute bottom-4 left-4 text-size-14 font-bold text-color-highlight truncate max-w-[80px]">
                          {schedulings.length === 0
                            ? ""
                            : schedulings.length === 1
                              ? schedulings[0].occurrence?.vehicleName ?? schedulings[0].occurrence?.vehicleChassis
                              : intl.formatMessage({ id: "intl-msg:dealership.month.vehiclesCount" }, { count: schedulings.length })}
                        </span>
                      </div>
                    </div>
                  </td>
                );
              })}
            </tr>
          )
        )}
        </tbody>
      </table>
    </div>
  );
};

export default Month;
